<template>
    <a-modal
        :visible="showPushRecords"
        :width="1200"
        title="素材推送记录"
        centered
        :footer="null"
        :mask-closable="false"
        @cancel="close"
    >
        <vxe-grid
            ref="tableGrid"
            v-bind="tableGrid"
            @page-change="handlePageChange"
            @checkbox-change="handleRowChange"
            @checkbox-all="handleRowChange"
        >
            <template #toolbar_buttons>
                <a-space>
                    <a-input
                        v-model="filters.material_name"
                        placeholder="素材名称"
                        allow-clear
                        style="width: 200px"
                    />
                    <a-select
                        v-model="filters.status"
                        placeholder="推送状态"
                        allow-clear
                        style="width: 120px"
                    >
                        <a-select-option :value="1">待推送</a-select-option>
                        <a-select-option :value="2">成功</a-select-option>
                        <a-select-option :value="3">失败</a-select-option>
                    </a-select>
                    <a-select
                        v-model="filters.media"
                        placeholder="媒体"
                        allow-clear
                        style="width: 120px"
                    >
                        <a-select-option :value="1">快手</a-select-option>
                        <a-select-option :value="2">巨量</a-select-option>
                    </a-select>
                    <a-button type="primary" @click="search">查询</a-button>
                    <a-button @click="resetSearch">重置</a-button>
                </a-space>
                <a-space style="float: right; margin-left: 16px">
                    <a-button
                        type="danger"
                        :disabled="selectedRowKeys.length === 0"
                        :loading="retryLoading"
                        @click="batchRetry"
                    >
                        批量重试
                    </a-button>
                </a-space>
            </template>

            <template #material_cover="{ row }">
                <a-popover v-if="row.material_cover" trigger="hover" placement="right">
                    <template #content>
                        <img :src="row.material_cover" style="width:240px;height:320px;object-fit:cover;border-radius:4px" />
                    </template>
                    <img :src="row.material_cover" style="width:60px;height:80px;object-fit:cover;border-radius:4px;cursor:pointer" />
                </a-popover>
                <span v-else>-</span>
            </template>

            <template #material_deleted_at="{ row }">
                <span v-if="row.material_deleted_at" style="color:red">已删除</span>
                <span v-else style="color:green">正常</span>
            </template>

            <template #target_advertiser_name="{ row }">
                {{ row.target_advertiser_name }}（{{ row.advertiser_id }}）
            </template>

            <template #source_advertiser_name="{ row }">
                {{ row.source_advertiser_name }}（{{ row.source_advertiser_id }}）
            </template>

            <template #status="{ row }">
                <a-tag :color="statusMap[row.status]?.color">
                    {{ statusMap[row.status]?.text || '未知' }}
                </a-tag>
            </template>

            <template #error_msg="{ row }">
                <span :title="row.error_msg" style="display:inline-block;max-width:180px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ row.error_msg || '-' }}</span>
            </template>

            <template #action="{ row }">
                <a-button
                    v-if="row.status === 3"
                    type="link"
                    size="small"
                    :loading="retryLoading"
                    @click="singleRetry(row)"
                >
                    重试
                </a-button>
                <span v-else>-</span>
            </template>
        </vxe-grid>
    </a-modal>
</template>

<script>
import PushRecords from './PushRecords'
export default PushRecords
</script>
